<script>
  import { Icon, Play } from "svelte-hero-icons";
  import { getPaymentLink } from "../../lib/stripe";
  import { onMount } from "svelte";
  import i18n from "@/lib/i18n";

  $: t = $i18n.getFixedT(null, null, "title");

  let customerCount = 3;
  let visitorCount = 30;
  let countdown = 120; // Countdown starts at two minutes (120 seconds)
  let minutes = Math.floor(countdown / 60);
  let seconds = countdown % 60;

  onMount(() => {
    // Initialize PostHog
    if (!window.posthog) {
      !(function (t, e) {
        var o, n, p, r;
        e.__SV ||
          ((window.posthog = e),
          (e._i = []),
          (e.init = function (i, s, a) {
            function g(t, e) {
              var o = e.split(".");
              2 == o.length && ((t = t[o[0]]), (e = o[1])),
                (t[e] = function () {
                  t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
                });
            }
            ((p = t.createElement("script")).type = "text/javascript"),
              (p.async = !0),
              (p.src = s.api_host + "/static/array.js"),
              (r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(
                p,
                r
              );
            var u = e;
            for (
              void 0 !== a ? (u = e[a] = []) : (a = "posthog"),
                u.people = u.people || [],
                u.toString = function (t) {
                  var e = "posthog";
                  return (
                    "posthog" !== a && (e += "." + a), t || (e += " (stub)"), e
                  );
                },
                u.people.toString = function () {
                  return u.toString(1) + ".people (stub)";
                },
                o =
                  "capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled onFeatureFlags getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures getActiveMatchingSurveys getSurveys".split(
                    " "
                  ),
                n = 0;
              n < o.length;
              n++
            )
              g(u, o[n]);
            e._i.push([i, s, a]);
          }),
          (e.__SV = 1));
      })(document, window.posthog || []);

      window.posthog.init("phc_7406qnbLDrulbmhd20k94o40ogazfgBoPekA3dOW1mv", {
        api_host: "https://app.posthog.com", // or your self-hosted URL
      });
      console.log("PostHog initialized");
    }
  });

  onMount(() => {
    // Get saved countdown or use default
    countdown = 120;
    minutes = Math.floor(countdown / 60);
    seconds = countdown % 60;

    const updateCustomerCount = () => {
      if (customerCount > 1) {
        customerCount -= 1;
      }
    };

    const updateVisitorCount = () => {
      visitorCount = Math.floor(Math.random() * (33 - 26 + 1)) + 25;
    };

    const updateCountdown = () => {
      if (countdown > 0) {
        countdown -= 1;
        minutes = Math.floor(countdown / 60);
        seconds = countdown % 60;
        // Save to localStorage
        localStorage.setItem("countdown", countdown.toString());
      }
    };

    const customerInterval = setInterval(updateCustomerCount, 30000);
    const visitorInterval = setInterval(updateVisitorCount, 3000);
    const countdownInterval = setInterval(updateCountdown, 1000);

    return () => {
      clearInterval(customerInterval);
      clearInterval(visitorInterval);
      clearInterval(countdownInterval);
    };
  });

  function handleConversion(e) {
    // Prevent immediate navigation
    e.preventDefault();

    // Get the href from the clicked element
    const href = e.currentTarget.href;

    // Send destination URL to PostHog
    if (window.posthog) {
      console.log("Sending PostHog event:", {
        event: "Checkout Click",
        properties: { destination: href },
      });
      window.posthog.capture("Checkout Click", {
        destination: href,
      });
    } else {
      console.log("PostHog not initialized");
    }

    // Trigger the Traffic Factory conversion
    if (window.tf_goal_473365127607badd19ea3b67cd5e490e) {
      window.tf_goal_473365127607badd19ea3b67cd5e490e.fire();
    }

    // Navigate after a small delay to ensure the conversion is tracked
    setTimeout(() => {
      window.location.href = href;
    }, 100);
  }
</script>

<div class="background-animation">
  <div class="circle circle1"></div>
  <div class="circle circle2"></div>
  <div class="circle circle3"></div>
  <div class="container">
    <div class="content-wrapper">
      <div class="text-content">
        <!-- Rating  -->
        <div class="rating-section">
          <span class="rating-number">4,8</span>
          <div class="rating-details">
            <span class="stars">★★★★★</span>
            <span class="rating-text">749 {t("rating")}</span>
          </div>
        </div>
        <h1 class="title">
          Find your precious lost gems -
          <span class="highlight tilted">all of them!</span>
        </h1>
        <p class="subtitle">
          Unique search tool + the biggest collection of <b>free sites</b> to rediscover
          deleted videos, full length versions or new material.
        </p>
        <!-- <div class="button-wrapper">
          <a
            href={getPaymentLink()}
            class="cta-button plausible-event-name=action"
            on:click={handleConversion}
          >
            <Icon
              src={Play}
              style="margin-right: 8px; width: 32px; height: 32px; font-weight: bold; fill: #000;"
            /> <span style="font-size: 1.25rem;">$5,99 USD</span>
            <div style="text-decoration: line-through;">$18,99</div>
          </a>
        </div>
        <p class="special-offer">
          <span class="offer-text">
            {t("time")}
            {minutes} min {seconds} sec
          </span>
        </p> -->
      </div>
      <div class="image-content">
        <img
          src="/cover111.png"
          alt="Descriptive Alt Text"
          class="responsive-image"
        />
      </div>
    </div>
  </div>
</div>

<style>
  .background-animation {
    position: relative;
    min-height: 100vh;
    background: linear-gradient(to bottom, #1a1a1a, #0f0f0f);
    overflow: hidden;
  }

  .circle {
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.03);
    animation: float 20s infinite linear;
    z-index: 1;
  }

  .circle1 {
    width: 400px;
    height: 400px;
    top: -100px;
    left: -100px;
    animation-delay: -5s;
  }

  .circle2 {
    width: 600px;
    height: 600px;
    bottom: -200px;
    right: -200px;
    animation-delay: -10s;
  }

  .circle3 {
    width: 300px;
    height: 300px;
    top: 50%;
    left: 50%;
    animation-delay: -15s;
  }
  @keyframes float {
    0% {
      transform: translate(0, 0) rotate(0deg);
    }
    33% {
      transform: translate(50px, 50px) rotate(120deg);
    }
    66% {
      transform: translate(-50px, 50px) rotate(240deg);
    }
    100% {
      transform: translate(0, 0) rotate(360deg);
    }
  }
  .container {
    position: relative;
    z-index: 2;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 16px;
    text-align: center;
    min-height: 90vh; /* Ensures the container is at least 80% of the screen height */
    display: flex;
    align-items: center; /* Vertically center the content-wrapper */
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .text-content {
    width: 100%;
  }

  .image-content {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 32px;
  }

  .responsive-image {
    max-width: 100%;
    height: auto;
    border-radius: 10px;
  }

  .title {
    font-size: 3.5rem; /* Further increased font size */
    font-weight: bold;
    margin-bottom: 16px;
    color: #f0f0f0; /* Less white */
    line-height: 1.1; /* Reduced line height */
  }
  .highlight {
    background-color: white;
    color: #1a1a1a;
    padding: 0 4px;
    font-size: 1em; /* Further increased font size */
    line-height: 1.3; /* Reduced line height */
    border-radius: 4px;
  }
  .tilted {
    display: inline-block;
    transform: rotate(-1deg); /* Tilt the text slightly */
  }
  .subtitle {
    font-size: 1.25rem;
    margin-bottom: 64px;
    color: gray;
  }
  .animated-price {
    animation: fadeInOut 1.5s infinite;
    font-size: 1.2rem; /* Increased font size */
  }
  @keyframes fadeInOut {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
  .button-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 16px; /* Add some space below the button */
  }
  .cta-button {
    background-color: #ffd700; /* Match the pricing card button color */
    color: #2c2c2c; /* Match the pricing card button text color */
    font-weight: bold;
    padding: 16px 64px; /* Increased padding */
    border: none;
    border-radius: 6px; /* Match the pricing card button border radius */
    cursor: pointer;
    transition:
      background-color 0.3s,
      transform 0.3s;
    width: auto; /* Do not use full width */
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px; /* Space between icon and text */
    text-decoration: none; /* Remove underline from link */
  }
  .cta-button:hover {
    background-color: #e5c100; /* Match the pricing card button hover color */
    transform: scale(1.05); /* Match the pricing card button hover transform */
  }
  .special-offer {
    font-size: 1rem;
    margin-top: 16px;
    color: #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500; /* Semibold */
  }
  .offer-text {
    color: #b7b7b7; /* Less bright green */
    animation: subtle-fade 3s infinite;
    margin-right: 5px;
  }

  .rating-section {
    font-size: 1.25rem;
    color: #ffd700;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding-bottom: 16px; /* Added padding bottom */
    padding-top: 32px;
  }
  .rating-number {
    font-size: 2.2rem; /* Increased font size for bigger appearance */
    font-weight: bold; /* Added bold for fatter appearance */
    color: #b0b0b0;
    margin-right: 4px;
  }
  .rating-details {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .stars {
    font-size: 1.2rem;
  }
  .rating-text {
    color: #808080; /* Darker gray color */
    font-size: 0.8rem; /* Smaller font size */
  }

  @keyframes subtle-fade {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.8;
    }
  }
  @media (max-width: 600px) {
    .title {
      font-size: 2.5rem; /* Original font size for mobile */
      line-height: 1.2; /* Reduced line height for mobile */
    }
    .highlight {
      font-size: 1em; /* Original font size for mobile */
    }
  }
  @media (min-width: 601px) {
    .subtitle {
      font-size: 1.5rem; /* Increased font size for tablet and desktop */
    }
  }
  @media (min-width: 768px) {
    .content-wrapper {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 32px;
    }

    .text-content {
      flex: 1;
      text-align: left;
    }

    .image-content {
      flex: 1;
      margin-top: 0;
    }

    .rating-section,
    .button-wrapper,
    .special-offer {
      justify-content: flex-start;
    }
  }
</style>
